export const ResourceControlOwnership = Object.freeze({
  PUBLIC: 'public',
  PRIVATE: 'private',
  RESTRICTED: 'restricted',
  ADMINISTRATORS: 'administrators',
});
